export const userConnected = () => {
  let accessToken = sessionStorage.getItem("accessToken");
  return accessToken != null || accessToken != undefined;
};
